import { isObjectDeeplyChanged } from '../../util/state';
import { State } from './selector';

/**
 * Update flags for AVC Container
 */
export const getUpdateFlags = (newState: State, oldState: State) => {
    const {
        error,
        addressForm,
        selectedAddress,
        addresses,
        address,
        isAvailabilityChecked,
    } = newState;

    const isAddressChanged = isObjectDeeplyChanged(selectedAddress, oldState.selectedAddress);
    const isFormChanged = isObjectDeeplyChanged(addressForm, oldState.addressForm);

    return {
        input: isFormChanged,
        notification: error !== oldState.error || addresses.length !== oldState.addresses.length,
        button: isAddressChanged || isFormChanged,
        address: address !== oldState.address,
        avc: isAvailabilityChecked !== oldState.isAvailabilityChecked,
    };
};
